import { IReview } from '@curbnturf/entities';
import { createAction, props } from '@ngrx/store';

export const init = createAction('[Reviews Page] Init');

export const createBoondockReview = createAction(
  '[Reviews] Create Boondock Site Reviews',
  props<{ boondockSiteId: number; review: IReview }>(),
);

export const createBoondockReviewSuccess = createAction(
  '[Reviews] Create Boondock Site Reviews Success',
  props<{ review: IReview }>(),
);

export const createBoondockReviewFailed = createAction(
  '[Reviews] Create Boondock Site Reviews Failed',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ error: any }>(),
);

export const createGuestReview = createAction(
  '[Reviews] Create Guest Reviews',
  props<{ guestId: number; review: IReview }>(),
);

export const storeGuestReview = createAction('[Reviews] Store Guest Review', props<{ review: IReview }>());

export const createGuestReviewSuccess = createAction(
  '[Reviews] Create Guest Reviews Success',
  props<{ review: IReview }>(),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createGuestReviewFailed = createAction('[Reviews] Create Guest Reviews Failed', props<{ error: any }>());

export const createPoiReview = createAction(
  '[Reviews] Create POI Reviews',
  props<{ poiId: number; review: IReview }>(),
);

export const createPoiReviewSuccess = createAction(
  '[Reviews] Create POI Reviews Success',
  props<{ review: IReview }>(),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createPoiReviewFailed = createAction('[Reviews] Create POI Reviews Failed', props<{ error: any }>());

export const createListingReview = createAction(
  '[Reviews] Create Listing Reviews',
  props<{ listingId: number; review: IReview }>(),
);

export const createListingReviewSuccess = createAction(
  '[Reviews] Create Listing Reviews Success',
  props<{ review: IReview }>(),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createListingReviewFailed = createAction('[Reviews] Create Listing Reviews Failed', props<{ error: any }>());

export const loadListingReviews = createAction('[Reviews] Load Listing Reviews', props<{ listingId: number }>());

export const loadListingReviewsSuccess = createAction(
  '[Reviews] Load Listing Reviews Success',
  props<{ reviews: IReview[] }>(),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadListingReviewsFailure = createAction('[Reviews] Load Listing Reviews Failure', props<{ error: any }>());

export const loadGuestReviews = createAction('[Reviews] Load Guest Reviews', props<{ guestId: number }>());

export const loadGuestReviewsSuccess = createAction(
  '[Reviews] Load Guest Reviews Success',
  props<{ reviews: IReview[] }>(),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadGuestReviewsFailure = createAction('[Reviews] Load Guest Reviews Failure', props<{ error: any }>());

export const loadBoondockReviews = createAction('[Reviews] Load Boondock Reviews', props<{ boondockId: number }>());

export const loadBoondockReviewsSuccess = createAction(
  '[Reviews] Load Boondock Reviews Success',
  props<{ reviews: IReview[] }>(),
);

export const loadBoondockReviewsFailure = createAction(
  '[Reviews] Load Boondock Reviews Failure',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ error: any }>(),
);

export const loadPoiReviews = createAction('[Reviews] Load POI Reviews', props<{ activityId: number }>());

export const loadPoiReviewsSuccess = createAction(
  '[Reviews] Load POI Reviews Success',
  props<{ reviews: IReview[] }>(),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadPoiReviewsFailure = createAction('[Reviews] Load POI Reviews Failure', props<{ error: any }>());
